import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]

import { onMounted, ref, nextTick, computed, watch } from "vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import { useWecomaIntegration } from "./use-wecoma-integration";
import { pushConsentBarShow, pushAllConsentBar, pushEssentialsConsentBar } from "./use-wecoma-datalayer";
import { useBreakpoints } from "../composables/use-breakpoints";
import { WecomaConstants } from "./wecoma-constants";
import { ContactWecomaKeys } from "../models/contact";


export default /*@__PURE__*/_defineComponent({
  __name: 'consent-bar',
  setup(__props) {

const {
    consentToAllPurposes,
    redirectToPreferenceCenter,
    redirectToPrivacyPolicy,
    consentToOnlyNecessaryPurposes,
    getWecomaKeysValue,
    canBeLoggedInWecoma,
} = useWecomaIntegration();

const header = environment.gdpr.gdprHeader;
const headerMobile = environment.gdpr.gdprHeaderMobile || environment.gdpr.gdprHeader;
const text = environment.gdpr.gdprMessage;
const textMobile = environment.gdpr.gdprMessageMobile || environment.gdpr.gdprMessage;
const textLoggedIn = environment.gdpr.gdprMessageLoggedIn || environment.gdpr.gdprMessage;
const textMobileLoggedIn = environment.gdpr.gdprMessageMobileLoggedIn || textLoggedIn;
const image = environment.gdpr.gdprImageUrl;

const wecomaUserKeys = ref<ContactWecomaKeys>();
const isLoggedInWecoma = computed(() => !!wecomaUserKeys.value);
const isSm2Up = useBreakpoints("sm2");

const hidingClass = ref("");
const hide = () => {
    hidingClass.value = "hiding";
    setTimeout(() => {
        hidingClass.value = "hidden";
    }, 500);
};

const consentAll = () => {
    setTimeout(() => {
        consentToAllPurposes(isLoggedInWecoma.value);
        pushAllConsentBar();
    }, 0);
    hide();
};

const consentToOnlyNecessary = () => {
    consentToOnlyNecessaryPurposes(isLoggedInWecoma.value);
    pushEssentialsConsentBar();
    hide();
};

const imageVisible = ref(true);
const hideKulicnik = (e) => {
    const sm2 = useBreakpoints("sm2");
    imageVisible.value = sm2.value || e?.target?.scrollTop === 0;
};

const headerToShow = computed(() => {
    return isSm2Up.value ? header : headerMobile;
});

const textToShow = computed(() => {
    if (isLoggedInWecoma.value) {
        return isSm2Up.value ? textLoggedIn : textMobileLoggedIn;
    }

    return isSm2Up.value ? text : textMobile;
});

watch(
    textToShow,
    () => {
        nextTick(() => {
            const preferenceCenterLink = isLoggedInWecoma.value
                ? `${appSettings["Integrations:Wecoma:Domain"]}?key=${WecomaConstants.WECOMA_CODE_DEH}&locale=cs-CZ&authKeys=${wecomaUserKeys.value.wecomaUserKey}`
                : `${appSettings["Integrations:Wecoma:Domain"]}?key=${WecomaConstants.WECOMA_CODE_DEH}&locale=cs-CZ&authKeys=${WecomaConstants.WECOMA_AUTHKEY}&contexts=consentbar&source=cookiebanner`;

            const prefCenterLinkElement = document.getElementById("consent-bar-preference-center") as HTMLAnchorElement;
            if (prefCenterLinkElement) {
                prefCenterLinkElement.href = preferenceCenterLink;
                prefCenterLinkElement.addEventListener("click", () =>
                    redirectToPreferenceCenter("text", isLoggedInWecoma.value)
                );
            }

            const privacyPolicyLinkElement = document.getElementById("consent-bar-privacy-policy") as HTMLAnchorElement;
            privacyPolicyLinkElement?.addEventListener("click", () => redirectToPrivacyPolicy(isLoggedInWecoma.value));
        });
    },
    { immediate: true }
);

onMounted(async () => {
    if (canBeLoggedInWecoma()) {
        wecomaUserKeys.value = await getWecomaKeysValue();
        pushConsentBarShow();
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["consent-bar", hidingClass.value]),
    "data-test": "consent-bar"
  }, [
    (imageVisible.value)
      ? (_openBlock(), _createBlock(WebpImage, {
          key: 0,
          src: _unref(image),
          alt: "cookie lišta",
          "css-class": "consent-bar__image"
        }, null, 8, ["src"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "consent-bar__content",
      ref: "contentSection",
      onScroll: hideKulicnik
    }, [
      _createElementVNode("h2", {
        class: "consent-bar__title",
        innerHTML: headerToShow.value
      }, null, 8, _hoisted_1),
      _createElementVNode("div", {
        class: "consent-bar__text",
        innerHTML: textToShow.value
      }, null, 8, _hoisted_2)
    ], 544),
    _createElementVNode("div", { class: "consent-bar__actions" }, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-sm btn-secondary",
        onClick: consentAll
      }, "Souhlasím se vším"),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-sm consent-bar__more",
        onClick: consentToOnlyNecessary
      }, " Pouze nezbytné ")
    ])
  ], 2))
}
}

})